import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import config from '../config';

const ReviewCollection = ({ testimonialList }) => {
  const isLoading = testimonialList === undefined || testimonialList === null;
  const isEmpty = Array.isArray(testimonialList) && testimonialList.length === 0;

  return (
    <div className="testimonial pt-5 pb-5">
      <div className="container position-relative">

        {isLoading ? (
          <div className="row">
            {[...Array(3)].map((_, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className="testimonial-skeleton skeleton-card"></div>
              </div>
            ))}
          </div>
        ) : isEmpty ? (
          <div className="text-center py-5">
            <img
              src="/images/empty-state.png"
              alt="No testimonials"
              style={{ maxWidth: '200px', marginBottom: '20px' }}
            />
            <h5>No testimonials available</h5>
            <p>We’ll add some soon!</p>
          </div>
        ) : (
          <>
            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={30}
              slidesPerView={3}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              loop={true}
              pagination={{ el: '.pagination-reviews', clickable: true }}
              breakpoints={{
                320: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {testimonialList.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div className="review_wrapper card h-100 border-0">
                    <div className="d-flex align-items-center mb-4">
                      <div className="profil_img me-3">
                        <img
                          src={testimonial.image}
                          className="img-fluid rounded-pill"
                          alt={testimonial.name}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = config.defaultImage;
                          }}
                        />
                      </div>
                      <div className="info">
                        <h3>{testimonial.name}</h3>
                        <p>{testimonial.designation}</p>
                      </div>
                    </div>
                    <div className="d-flex">
                      <div className="desc">
                        <span>❝</span>
                        {testimonial.message}
                        <span>❞</span>
                        <div className="divider"></div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <div className="pagination-reviews"></div>
          </>
        )}
      </div>
    </div>
  );
};

export default ReviewCollection;
